// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19KMH","top":"styles_top__1dZvc","left":"styles_left__35LIK","description":"styles_description__S6yG8"};